module.exports = __webpack_public_path__ + "img/business_10.8c44c7ac.jpg";